module.exports = __webpack_public_path__ + "bc4855eb33646dfdb9ba73cf5ea2143c.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/unleash_giants_2-768.jpg
// module id = 581
// module chunks = 0